import { render, staticRenderFns } from "./userCommentElement.vue?vue&type=template&id=1edd6281&scoped=true"
import script from "./userCommentElement.vue?vue&type=script&lang=js"
export * from "./userCommentElement.vue?vue&type=script&lang=js"
import style0 from "./userCommentElement.vue?vue&type=style&index=0&id=1edd6281&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edd6281",
  null
  
)

export default component.exports